import {Directive, HostListener} from '@angular/core';

@Directive({
  selector: '[appDateInput]',
  standalone: true
})
export class DateInputDirective {
  private allowedCharacters = /[0-9.]/;

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    const inputChar = event.key;
    const inputValue = (event.target as HTMLInputElement).value;

    if (inputValue.length === 0 && inputChar === '.') {
      event.preventDefault();
      return;
    }

    if (this.isNavigationOrDeletionKey(inputChar)) {
      return;
    }

    if (this.isConsecutiveDot(inputChar, inputValue)) {
      event.preventDefault();
      return;
    }

    if (this.exceedsTwoDots(inputChar, inputValue)) {
      event.preventDefault();
      return;
    }

    if (!this.allowedCharacters.test(inputChar)) {
      event.preventDefault();
    }
  }

  private isNavigationOrDeletionKey(inputChar: string): boolean {
    const navigationKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
    return navigationKeys.includes(inputChar);
  }

  private isConsecutiveDot(inputChar: string, inputValue: string): boolean {
    return inputChar === '.' && inputValue[inputValue.length - 1] === '.';
  }

  private exceedsTwoDots(inputChar: string, inputValue: string): boolean {
    const dotCount = (inputValue.match(/\./g) || []).length;
    return inputChar === '.' && dotCount >= 2;
  }
}
